import './style.scss';

const Spinner = () =>
(
    <div>
        <main>
            <div className="container">
                <div className="col-3">
                    <div className="snippet" data-title=".dot-spin">
                        <div className="stage">
                            <div className="dot-spin"></div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
)


export default Spinner;